<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
        style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
        grow
        background-color="primary"
        active-class="subtitle-1 font-weight-bold"
        center-active
        v-model="activeTab"
      >
        <v-tab class="tabText" @click.prevent="setGetFavoritas(false)" :key="0">
          Enquetes
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === false && !loading && data.totalItems > 0) }">
            {{ flg_favorita === false && !loading && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>

        <!--
          *** FAVORITAS TAB DESATIVADA ***
          A funcionalidade de favoritar as enquetes foi temporariamente desativada.
          TODO: o código referente a essa aba foi comentado para futura reutilização.

        <v-tab class="tabText" @click.prevent="setGetFavoritas(true)" :key="1">
          Favoritas
          {{
            `${flg_favorita === true && !loading ? `(${data.totalItems})` : ''}`
          }}
        </v-tab>
        -->
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid v-if="cod_producao">
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            @keypress.enter="handleClickEnter"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-select
            v-if="activeTab === 0 && $store.state.enquetes.selectedPortal"
            v-model="selectedCategoria"
            :items="categorias"
            placeholder="Escolha a categoria"
            aria-label="Escolha a categoria de enquete"
            solo flat dense hide-details
            background-color="surface_tertiary"
            item-value="id"
            item-text="dsc_nome_categoria"
            @change="handleChangeCategoria"
            class="colab-dropdown"
          >
            <template v-slot:append-item>
              <v-list-item @click="resetSelection">
                <v-list-item-title>Escolha a categoria</v-list-item-title>
              </v-list-item>
            </template>
          </v-select>
        </div>

        <div v-if="data" class="columnWrapper">
          <template>
            <div
              v-for="item in data.items"
              :key="item.cod_noticia"
              class="card-item-wrapper drag-source"
              :class="{ 'drag-source--dragging': draggingId === item.id }"
              draggable
              @dragstart="startDrag($event, item)"
              @dragend="endDrag"
            >
              <CardEnqueteRecebida
                :item="item"
                :get-enquetes-producao="getEnquetesProducao"
                :get-enquete-em-exibicao="getEnqueteEmExibicao"
                :current-page="currentEnquetesPage"
                :is-favorita-tab="flg_favorita"
                @reload-enquetes="reloadAllEnquetes"
              />
            </div>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import CardEnqueteRecebida from "../Cards/Enquetes/CardEnqueteRecebida.vue";
import { mapActions } from "vuex";
import { capitalizeString } from "@/utils/capitalizeString";
import { dragSourceMixin } from "@/mixins/dragAndDrop";

export default {
  mixins: [dragSourceMixin],
  components: {
    CardEnqueteRecebida,
  },
  props: {
    data: { type: [Array, Object] },
    currentEnquetesPage: Number,
    cod_producao: Number,
  },
  data() {
    return {
      imagem_url: "",
      isModalFiltrosVisible: false,
      filtro_texto: "",
      flg_favorita: false,
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      debounce: null,
      loading: false,
      activeTab: 0,
      selectedCategoria: this.$store.state.enquetes.selectedCategoria || null,
      isSelectingCategoria: false,
      dragIdField: 'id',
    };
  },

  async created() {
    if (this.$store.state.enquetes.selectedPortal) {
      await this.getCategoriasPorPortal({
        id_portal: this.$store.state.enquetes.selectedPortal,
      });

      const storedCat = localStorage.getItem("@socialcam/cod_categoria_enquetes");
      if (storedCat && storedCat !== "" && storedCat !== "null") {
        const catId = isNaN(storedCat) ? storedCat : Number(storedCat);
        this.selectedCategoria = catId;
        await this.setSelectedCategoria(catId);
        await this.getEnquetes();
      } else {
        await this.trySelectFirstCategoria();
      }
    }
  },
  beforeMount() {
    this.filtro_texto = localStorage.getItem("@socialcam/filtro_texto_enquetes") || "";
    this.flg_favorita =
      JSON.parse(localStorage.getItem("@socialcam/flg_favorita_enquetes")) || false;
    this.activeTab = this.flg_favorita ? 1 : 0;
    this.setFlgFavorita(this.flg_favorita);
  },

  computed: {
    categorias() {
      const categorias = this.$store.getters["enquetes/getterPortaisCategorias"];
      return categorias || [];
    },
  },

  methods: {
    ...mapActions({
      getEnquetesProducao: "enquetes/getEnquetesProducao",
      getEnqueteEmExibicao: "enquetes/getEnqueteEmExibicao",
      setFlgFavorita: "enquetes/setFlgFavorita",
      setFiltroEnquetes: "enquetes/setFiltroEnquetes",
      getCategoriasPorPortal: "enquetes/getCategoriasPorPortal",
      setSelectedCategoria: "enquetes/setSelectedCategoria",
    }),

    async trySelectFirstCategoria() {
      if (this.isSelectingCategoria) return;
      if (this.selectedCategoria) return;

      try {
        this.isSelectingCategoria = true;
        this.selectedCategoria = null;
        await this.setSelectedCategoria(null);
        await this.getEnquetes();
      } finally {
        this.isSelectingCategoria = false;
      }
    },

    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },

    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },

    capitalize(string) {
      return capitalizeString(string);
    },

    async handleClickEnter() {
      await this.getEnquetes();
    },

    async getEnquetes() {
      if (!this.cod_producao) {
        console.error("No production selected for getEnquetes");
        return;
      }

      try {
        await this.getEnquetesProducao({
          cod_producao: this.cod_producao,
          filtro_texto: this.$store.state.enquetes.filtroEnquetes,
          size: 5,
          page: this.currentEnquetesPage,
          cod_portal: this.$store.state.enquetes.selectedPortal,
          id_categoria: this.selectedCategoria,
        });
      } catch (error) {
        console.error("Error fetching enquetes:", error);
        this.$toast.error("Erro ao carregar enquetes");
      }
    },

    async reloadAllEnquetes() {
      try {
        await Promise.all([
          this.getEnquetes(),
          this.getEnqueteEmExibicao({ cod_producao: this.cod_producao }),
        ]);
      } catch (error) {
        console.error("Error reloading enquetes:", error);
        this.$toast.error("Erro ao recarregar enquetes");
      }
    },

    async handleChangeCategoria() {
      try {
        this.loading = true;
        await this.setSelectedCategoria(this.selectedCategoria);
        localStorage.setItem("@socialcam/cod_categoria_enquetes", this.selectedCategoria ?? "");
        await this.getEnquetes();
      } catch (error) {
        console.error(error);
        return this.$toast.error("Não foi possível filtrar por categoria");
      } finally {
        this.loading = false;
      }
    },

    resetSelection() {
      this.selectedCategoria = null;
      this.setSelectedCategoria(null);
      localStorage.setItem("@socialcam/cod_categoria_enquetes", "");
      this.handleChangeCategoria(null);
    },

    async setGetFavoritas(flg_favorita) {
      this.flg_favorita = flg_favorita;
      localStorage.setItem("@socialcam/flg_favorita_enquetes", flg_favorita);
      try {
        this.loading = true;
        await this.getEnquetes();
      } catch (error) {
        console.error(error);
        return this.$toast.error("Não foi possível buscar as favoritas");
      } finally {
        this.loading = false;
      }
    },

    onChange(e) {
      localStorage.setItem("@socialcam/filtro_texto_enquetes", e);
      this.setFiltroEnquetes(e);
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        try {
          await this.getEnquetes();
        } catch (error) {
          console.error("Error in debounced search:", error);
          this.$toast.error("Erro ao buscar enquetes");
        }
      }, 1500);
    },
  },

  watch: {
    /*
    // Watcher desativado junto com a aba Favoritas
    activeTab (newValue) {
      this.setFlgFavorita(newValue === 1)
    },
    */
    "$store.state.enquetes.selectedPortal": async function (newValue, oldValue) {
      if (!newValue) return;
      await this.getCategoriasPorPortal({ id_portal: newValue });

      // Only reset categoria if user actually changed portals (not initial restore)
      const storedCategoria = localStorage.getItem("@socialcam/cod_categoria_enquetes");
      if (oldValue && String(oldValue) !== String(newValue)) {
        this.selectedCategoria = null;
        await this.setSelectedCategoria(null);
        localStorage.setItem("@socialcam/cod_categoria_enquetes", "");
        await this.trySelectFirstCategoria();
      } else if (storedCategoria && storedCategoria !== "" && storedCategoria !== "null") {
        const catId = isNaN(storedCategoria) ? storedCategoria : Number(storedCategoria);
        this.selectedCategoria = catId;
        await this.setSelectedCategoria(catId);
        await this.getEnquetes();
      } else {
        await this.trySelectFirstCategoria();
      }
    },
    "$store.state.enquetes.categorias": "trySelectFirstCategoria",
  },

  beforeDestroy() {
    if (this.debounce) {
      clearTimeout(this.debounce);
      this.debounce = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.v-text-field__details {
  display: none !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
